export const agreementText = () => {
  return `
<p>
京东电影购票协议<br/><br/>
<strong>用户点击同意本协议之前，请务必认真阅读、完全理解本协议中全部条款，特别是其中与用户权益有或可能具有重大关系的条款&nbsp;(包括但不限于第1.1条、第1.2条、第1.3条第2.2条)</strong>。当用户按照页面提示阅读、点击确认同意本协议及完成支付购票时，即表示用户已经充分阅读、理解并接受本协议的全部内容。如用户不同意接受本协议的任何条款或无法理解本协议相关条款含义的，请不要进行后续操作(包括但不限于点击确认或继续使用京东电影平台服务等)</p>
<p>1.购票须知</p>
1.1&nbsp;请确认场次和时间无误，购买成功后将不可退票，不可改签;<br />
1.2&nbsp;由于影院设备故障、片方原因、政策原因等不可抗力因素，存在少量场次取消的情况，京东电影会接到影院通知后，为用户进行退票退款;<br />
1.3&nbsp;由于影院系统不稳定等因素，导致出票失败的情况京东电影会尽快安排退款;<br />
1.4&nbsp;如发现作弊行为&nbsp;(包括但不限于批量刷单、恶意投诉等)，京东电影有权取消该用户后续的退换票购票资格，必要时追究法律责任。<br />
<p>2.其他</p>
2.1&nbsp;用户使用退换服务有任何问题，可随时联系京东电影在线客服。如涉及与影院退换规则相关的事项，京东电影将尽力协助用户与影院进行沟通。<br />
2.2&nbsp;<strong>京东电影平台如根据自身运营和管理需要不定期修订本协议及/或相关服务规则，将提前7日在京东电影平台予以公示，不再向用户单独通知。用户如不接受变更后条款、内容、规则，有权立即停止使用平台服务，用户如继续使用平台服务，则视为接受变更后的条款、内容、规则。请用户注意及时查阅。</strong>
<br />
`
}
export const returnChange = (info = {}) => {
    return `
<p><strong>账号：</strong>${info?.pin ?? '--'}</p>
<p><strong>首次签署时间：</strong>${info?.signTimeStr ?? '--'}</p>
<p><strong>近期签署时间：</strong>${info?.lastSignTimeStr ?? '--' }</p>
<p>京东电影购票协议<br />用户点击同意本协议之前，请务必认真阅读、完全理解本协议中全部条款，特别是其中与用户权益有或可能具有重大关系的条款 (包括但不限于第1.1条、第1.2条、第1.3条第2.2条)。当用户按照页面提示阅读、点击确认同意本协议及完成支付购票时，即表示用户已经充分阅读、理解并接受本协议的全部内容。如用户不同意接受本协议的任何条款或无法理解本协议相关条款含义的，请不要进行后续操作(包括但不限于点击确认或继续使用京东电影平台服务等)<br />1.购票须知<br />1.1 请确认场次和时间无误，购买成功后将不可退票，不可改签;<br />1.2 由于设备故障、片方原因、政策原因等不可抗力因素，存在少量场次取消的情况，京东电影会接到影院通知后，为用户进行退票退款;<br />1.3 由于影院系统不稳定等因素，导致出票失败的情况京东电影会尽快安排退款;<br />1.4 如发现作弊行为 (包括但不限于批量刷单、恶意投诉等)，京东电影有权取消该用户后续的退换票购票资格.必要时追究法律责任。<br />2其他<br />2.1 用户使用退换服务有任何问题，可随时拨打京东电影客服电话。如涉及与影院退换规则相关的事项，京东电影将尽力协助用户与影院进行沟通。<br />2.2 京东电影平台如根据自身运营和管理需要不定期修订本协议及/或相关服务规则，将提前7日在京东电影平台予以公示，不再向用户单独通知。用户如不接受变更后条款、内容、规则，有权立即停止使用平台服务，用户如继续使用平台服务，则视为接受变更后的条款、内容、规则。请用户注意及时查阅。</p><br /><br /><br />
`
}
